<script lang="ts" setup>
import type {
  ComponentData,
  ComponentDataWithFreeText,
} from '@autobid/ui/types/components/DetailsTitleWithContent'

interface Props {
  data: ComponentData | ComponentDataWithFreeText | { display: false }
}

defineProps<Props>()
</script>

<template>
  <div v-if="data.display" class="col-span-12 lg:col-span-6">
    <SectionsDetailsElementsSection>
      <template #heading>
        {{ data.title }}
      </template>

      <template #content>
        <template v-if="'content' in data">
          <SectionsDetailsElementsList
            v-if="Array.isArray(data.content)"
            :elements="data.content"
          />
          <div v-else class="whitespace-pre-line">
            {{ data.content }}
          </div>
        </template>

        <template v-else>
          <SectionsDetailsElementsList
            v-if="data.list.length"
            :elements="data.list"
          />

          <SectionsDetailsElementsFreeText
            v-if="data.freeText.length"
            :has-border="data.list.length > 0"
            :free-text="data.freeText"
          />
        </template>
      </template>
    </SectionsDetailsElementsSection>
  </div>
</template>
